<template>
  <div>
    <div class="form-group boolean program_consent">
      <div class="checkbox">
        <label
          class="program-consent-label"
          for="program-consent-checkbox"
        >
          <input
            id="program-consent-checkbox"
            v-model="acceptedProgramConsent"
            :class="`program-consent-checkbox ${ rwcOrSportsnet ? 'rwc-or-sportsnet' : '' }`"
            type="checkbox"
            name="program_consent_checkbox"
            @change="updateProgramConsent"
          >
          <span
            class="custom-checkbox"
          />
          <div class="program-consent-text-wrapper">
            <!-- eslint-disable vue/no-v-html -->
            <span
              class="program-consent-text"
              v-html="programConsentVerbiage"
            />
            <!-- eslint-enable -->
          </div>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgramConsentCheckbox',
  data() {
    return {
      acceptedProgramConsent: false
    }
  },
  computed: {
    programConsentVerbiage() {
      if (['Rugby World Cup Experiences', 'Sportsnet Holidays'].includes(window.brand_name)){
        return this.$t('creditCardForm.rwcProgramConsent')
      } else {
        return this.$t('creditCardForm.programConsent')
      }
    },

    rwcOrSportsnet() {
      return ['Rugby World Cup Experiences', 'Sportsnet Holidays'].includes(window.brand_name)
    }
  },
  methods: {
    updateProgramConsent() {
      this.$emit('update-program-consent', this.acceptedProgramConsent)
    }
  },
}

</script>